// extracted by mini-css-extract-plugin
export default {"titleRow":"Table_titleRow__j73ZR","description":"Table_description__gTSe-"};